export const createFileKey = (fieldName: string, filename: string): string =>
  `${fieldName}:${filename}`;
